export default [
	{
		title: 'ADDRESS',
		description: '#20/17, 16th Cross, Ganesh Temple Road, Lakkasandra, Bangalore-30.',
 		 
 	},
	{
		title: 'PHONE NUMBER',
		description: '+91 990 292 8259',
 	 
 	},
	{
		title: 'EMAIL',
		description: 'sures.p3@gmail.com',
 	 
 	}
	 
	
];